import React from 'react';

type Props = {
  eventType: string;
};

const typeStyles: Record<string, string> = {
  triathlon: 'bg-brand-50 text-brand-700',
  duathlon: 'bg-brand-50 text-brand-700',
  aquathlon: 'bg-brand-50 text-brand-700',
  run: 'bg-accent-50 text-accent-700',
  'trail run': 'bg-emerald-50 text-emerald-700',
  swim: 'bg-sky-50 text-sky-700',
  swimrun: 'bg-cyan-50 text-cyan-700',
  cycle: 'bg-amber-50 text-amber-700',
};

const EventTypeTag: React.FC<Props> = ({ eventType }) => {
  const styles = typeStyles[eventType.toLowerCase()] ?? 'bg-surface-subtle text-ink-muted';

  return (
    <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${styles}`}>
      {eventType}
    </span>
  );
};

export default EventTypeTag;
